module.exports = __webpack_public_path__ + "img/logo.b3a9b4b1.jpg";